import { render, staticRenderFns } from "./festival.vue?vue&type=template&id=38ea1b92&scoped=true&"
import script from "./festival.vue?vue&type=script&lang=js&"
export * from "./festival.vue?vue&type=script&lang=js&"
import style0 from "./festival.vue?vue&type=style&index=0&id=38ea1b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea1b92",
  null
  
)

export default component.exports